

//
import { NGXLogger } from "ngx-logger";
import { ToolButtonType, IButtonTool, authAs, authOpt, authType } from "../definitions";
import { MapController } from "./map-controller";


import Control from 'ol/control/Control';

export class MapCtrlHeaderFooter {
    public constructor(public mapCtrl: MapController, private $log: NGXLogger) {

    };
    public loadMapHeaderHtml() {
        this.mapCtrl.mapHeaderHtml = "---";
        let mapHeaderId = "1";
        this.mapCtrl.showMapHeader = false;
        this.mapCtrl.showMapHeader = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_map_header_visible, authType.object);
        if (this.mapCtrl.showMapHeader) {
            for (let index = 1; index <= 10; index++) {
                let mapHeaderNameInfo = this.mapCtrl.userSettingsSrvs.isAuthForItemOption_Id_FullInfo(authOpt.info_control_map_header_source, authAs.control_map_header_visible, index, authType.object)
                if (mapHeaderNameInfo && mapHeaderNameInfo.idItem) {
                    mapHeaderId = mapHeaderNameInfo.idItem.toString();
                    break;
                }
            }
            //
            this.mapCtrl.userSettingsSrvs.getMapHeaderHtml(mapHeaderId)
                .then((data) => {
                    if (data && data.length > 0) {
                        this.mapCtrl.mapHeaderHtml = data;
                    }
                }).catch((reason) => {
                    this.$log.error("eroare la interogare continut header: ", reason);
                })
        }
    }
    public loadMapFooterHtml() {
        this.mapCtrl.mapFooterHtml = "---";
        let mapFooterId = "1";
        this.mapCtrl.showMapFooter = false;
        this.mapCtrl.showMapFooter = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_map_footer_visible, authType.object);
        if (this.mapCtrl.showMapFooter) {
            for (let index = 1; index <= 10; index++) {
                let mapFooterNameInfo = this.mapCtrl.userSettingsSrvs.isAuthForItemOption_Id_FullInfo(authOpt.info_control_map_footer_source, authAs.control_map_footer_visible, index, authType.object)
                if (mapFooterNameInfo && mapFooterNameInfo.idItem) {
                    mapFooterId = mapFooterNameInfo.idItem.toString();
                    break;
                }
            }
            //
            this.mapCtrl.userSettingsSrvs.getMapFooterHtml(mapFooterId)
                .then((data) => {
                    if (data && data.length > 0) {
                        this.mapCtrl.mapFooterHtml = data;
                    }
                }).catch((reason) => {
                    this.$log.error("eroare la interogare continut footer: ", reason);
                })
        }
    }

    public showFooterHeaderFullScreen() {
        if (this.mapCtrl.showMapHeader || this.mapCtrl.showMapFooter) {
            if (this.mapCtrl.headerFooterFullscreenButtonCtrl) {
                $(this.mapCtrl.headerFooterFullscreenButtonCtrl).removeClass('header-footer-fullscreen-button-hide');
            } else {
                //do add button to map
                this.mapCtrl.headerFooterFullscreenButton = document.createElement('button');
                this.mapCtrl.headerFooterFullscreenButton.innerHTML = '<i class="fas fa-expand"></i>';
                this.mapCtrl.headerFooterFullscreenButton.title = $localize`activează/dezactivează full screen`;
                $(this.mapCtrl.headerFooterFullscreenButton).tooltip({ placement: "right" });
                this.mapCtrl.headerFooterFullscreenButtonCtrl = document.createElement('div');
                this.mapCtrl.headerFooterFullscreenButtonCtrl.className = 'header-footer-fullscreen-button ol-unselectable left-tool-button';
                this.mapCtrl.headerFooterFullscreenButtonCtrl.appendChild(this.mapCtrl.headerFooterFullscreenButton);

                this.mapCtrl.headerFooterFullscreenButton.addEventListener('click', (event) => { this.onClickFullscreenButton(event, ToolButtonType.distance) });
                this.mapCtrl.leftButtonsTool.appendChild(this.mapCtrl.headerFooterFullscreenButtonCtrl);

                this.mapCtrl.headerFooterFullscreenStateOn = false;
            }
            
        } else {
            if (this.mapCtrl.headerFooterFullscreenButtonCtrl) {
                $(this.mapCtrl.headerFooterFullscreenButtonCtrl).addClass('header-footer-fullscreen-button-hide');
            }
        }
    }

    public onClickFullscreenButton(event, type) {
        //todo 
        if (this.mapCtrl.headerFooterFullscreenStateOn === true) {
            let tmpShowMapFooter = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_map_footer_visible, authType.object);
            if (this.mapCtrl.showMapFooter === false && tmpShowMapFooter) {
                this.mapCtrl.showMapFooter = true;
            }

            let tmpShowMapHeader = this.mapCtrl.userSettingsSrvs.isAuthForResource(authAs.control_map_header_visible, authType.object);
            if (this.mapCtrl.showMapHeader === false && tmpShowMapHeader) {
                this.mapCtrl.showMapHeader = true;
            }
            this.mapCtrl.headerFooterFullscreenStateOn = false;
            $(this.mapCtrl.headerFooterFullscreenButtonCtrl).removeClass('select-button-on');
        } else {
            this.mapCtrl.showMapFooter = false;
            this.mapCtrl.showMapHeader = false;
            this.mapCtrl.headerFooterFullscreenStateOn = true;
            $(this.mapCtrl.headerFooterFullscreenButtonCtrl).addClass('select-button-on');
        }

    }


}